export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DISABLE = 'DISABLE',
}

export type UserModel = {
  id?: number;
  userId?: number;
  doneTest: boolean;
  lastTestId: number;
  lastName: string;
  email: string;
  name: string;
  password: string;
  registrationDate: string;
  mobileNumber: string;
};

type Products = {
  productId: number;
  selected: boolean;
};

export type UserSelectedModel = {
  userId: number;
  fullName: string;
  products: Products[];
};

export enum DegreeLevel {
  PHD = 'PHD',
  MASTER = 'MASTER',
  BACHELOR = 'BACHELOR',
  ASSOCIATE = 'ASSOCIATE',
}

export interface TEducation {
  id: number;
  degreeLevel?: DegreeLevel;
  major: string;
  university: string;
  fromYear: string;
  endYear: string;
  iAmStillStudying?: boolean;
}

export interface TWorkExperience {
  id: number;
  jobTitle: string;
  companyName: string;
  fromMonth: string;
  fromYear: string;
  toMonth: string;
  toYear: string;
  itIsMyCurrentJob?: boolean;
}
